import { useEffect, useRef, useState } from "react";

const TypewriterComponent = ({
  text,
  speed = 55, // ms/char khi gõ
  eraseSpeed = 35, // ms/char khi xóa
  startDelay = 200, // trễ trước khi bắt đầu gõ (ms)
  pause = 1200, // nghỉ sau khi gõ xong / xóa xong (ms)
  loop = false, // false | true (vô hạn) | number (lặp N lần)
  erase = true, // true: gõ→nghỉ→xóa→nghỉ→gõ lại; false: gõ→nghỉ→reset→gõ lại
  showCursor = true,
  cursorChar = "|",
  className = "",
}) => {
  const [out, setOut] = useState("");
  const [done, setDone] = useState(false);

  const idxRef = useRef(0);
  const timerRef = useRef(null);
  const phaseRef = useRef("idle"); // idle | typing | pausing | erasing
  const charsRef = useRef([...text]);
  const loopsLeftRef = useRef(
    loop === true ? Infinity : Number.isFinite(loop) ? Number(loop) : 0
  );

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const schedule = (ms, fn) => {
    clearTimer();
    timerRef.current = setTimeout(fn, ms);
  };

  const resetState = () => {
    clearTimer();
    setOut("");
    setDone(false);
    idxRef.current = 0;
    phaseRef.current = "idle";
    charsRef.current = [...text];
    loopsLeftRef.current = loop === true ? Infinity : Number(loop) || 0;
  };

  useEffect(() => {
    resetState();
    // bắt đầu sau startDelay
    schedule(startDelay, () => {
      phaseRef.current = "typing";
      tick();
    });

    return () => clearTimer();
    // restart khi đổi các tham số chính
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, speed, eraseSpeed, startDelay, pause, loop, erase]);

  const tick = () => {
    const chars = charsRef.current;

    if (phaseRef.current === "typing") {
      if (idxRef.current < chars.length) {
        idxRef.current += 1;
        setOut(chars.slice(0, idxRef.current).join(""));
        schedule(speed, tick);
      } else {
        // gõ xong
        if (loop === false || loopsLeftRef.current === 0) {
          setDone(true);
          phaseRef.current = "idle";
          return;
        }
        // chuẩn bị xóa hoặc reset rồi lặp
        phaseRef.current = "pausing";
        schedule(pause, () => {
          if (erase) {
            phaseRef.current = "erasing";
            tick();
          } else {
            // reset nhanh rồi lặp
            idxRef.current = 0;
            setOut("");
            phaseRef.current = "pausing";
            schedule(pause, () => {
              phaseRef.current = "typing";
              tick();
            });
          }
        });
      }
      return;
    }

    if (phaseRef.current === "erasing") {
      if (idxRef.current > 0) {
        idxRef.current -= 1;
        setOut(chars.slice(0, idxRef.current).join(""));
        schedule(eraseSpeed, tick);
      } else {
        // xóa xong, trừ vòng lặp và gõ lại
        if (Number.isFinite(loopsLeftRef.current) && loopsLeftRef.current > 0) {
          loopsLeftRef.current -= 1;
        }
        phaseRef.current = "pausing";
        schedule(pause, () => {
          phaseRef.current = "typing";
          tick();
        });
      }
      return;
    }
  };

  return (
    <span className={className} aria-live="polite">
      {out}
      {showCursor && !done && <span className="caret-blink">{cursorChar}</span>}
    </span>
  );
};

export default TypewriterComponent;
